import {Injectable} from '@angular/core';
import {ParamService} from './param.service';
import { environment } from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class B4UService {
    banner = this.paramService.banner;
    public _window: any = window;
    public activeSortEmitter = new BehaviorSubject<any>({});
    public getActiveSortEmitter = this.activeSortEmitter.asObservable();

    public constructor(
        private paramService: ParamService,
        private http: HttpClient) {
    }

    getLocationHref() {
        return window.location.href;
    }

    getLocationHost() {
        return window.location.host;
    }

    getLocationOrigin() {
        return window.location.origin;
    }

    getEnvironment() {
        let environment;
        const origin = this.getLocationOrigin();
        if (origin.indexOf('qa1') > 0 || origin.indexOf('qa2') > 0 || origin.indexOf('qa3') > 0 || origin.indexOf('stage') > 0) {
            environment = this.getLocationHost().split('-')[1].split('.')[0];
        } else if (origin.indexOf('local') > 0) {
            environment = 'qa1';
        } else {
            environment = 'prod';
        }
        return environment;
    }

    getTrueEnvironmentDevOnly() {
        let environment;
        const origin = this.getLocationOrigin();
        if (origin.indexOf('qa1') > 0 || origin.indexOf('qa2') > 0 || origin.indexOf('qa3') > 0 || origin.indexOf('stage') > 0) {
            environment = this.getLocationHost().split('-')[1].split('.')[0];
        } else if (origin.indexOf('local') > 0) {
            environment = 'local';
        } else {
            environment = 'prod';
        }
        return environment;
    }

    getApplicationDomainURL() {
        let domain;
        if (this.getLocationHref().indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + this.getLocationHost();
        }
        return domain;
    }

    parseJwt(jwtToken: string) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    getUserClaims(user: any) {
        const oktaToken = this.parseJwt(user.SWY_SHOP_TOKEN);
        const userClaims = {
            aln: oktaToken['aln'],
            hid: oktaToken['hid'],
            zip: oktaToken['zip'],
            gid: oktaToken['gid'],
            uuid: oktaToken['uuid']
        };
        return userClaims;
    }
}
